import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatLegacyDialog as MatDialog, MatLegacyDialogConfig as MatDialogConfig } from '@angular/material/legacy-dialog';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { DialogSpinner } from 'app/commons/dialog-spinner/dialog-spinner.component';

@Component({
  selector: 'app-lgpd-aceite-modal',
  templateUrl: './lgpd-aceite-modal.html',
  standalone:true,
  imports:[CommonModule, TranslateModule, FormsModule]
})
export class LgpdAceiteModal implements OnInit {

  @Input() lgpd: any;
  title: string;
  description: string;
  aceitouTermos: boolean;
  msgSalvandoAceite: string;

  constructor(public activeModal: NgbActiveModal,
    private dialog: MatDialog,
    private translate: TranslateService) { }

  ngOnInit() {
    this.aceitouTermos = false;

    if (!this.lgpd.possuiAceite) {
      this.title = this.translate.instant('MODAL_LGPD_TITULO_TERMOS_USO_POLITICA_PRIVACIDADE');
      this.description = this.translate.instant('MODAL_LGPD_MSG_TERMOS_USO_POLITICA_PRIVACIDADE');
      return;
    }

    this.title = this.translate.instant('MODAL_LGPD_TITULO_TERMOS_USO_POLITICA_PRIVACIDADE_ALTERADA');
    this.description = this.translate.instant('MODAL_LGPD_MSG_TERMOS_USO_POLITICA_PRIVACIDADE_ALTERADA');
  }

  confirmModel() {
    this.activeModal.close();
  }

  showProgressSpinner() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;

    dialogConfig.data = {
      id: 'dialog-spinner-add-chamado',
      msg: this.translate.instant('MODAL_LGPD_MSG_SALVANDO_ACEITE')
    };
    this.dialog.open(DialogSpinner, dialogConfig);
  }

  hideProgressSpinner() {
    this.dialog.closeAll();
  }

  gerarTermoDeUsoIntegrador() {
    let nomeIntegrador = "SCOND"
    if(this.lgpd && this.lgpd.nomeIntegrador) {
      nomeIntegrador = this.lgpd.nomeIntegrador;
    }
    return this.translate.instant('LGPD_ACEITE', {nomeIntegrador: nomeIntegrador})
  }

}
